"use client";
import styled, { keyframes } from "styled-components";
import { defaultTheme } from "../styles/defaultTheme";
import { hexToRgb, RGB } from "../utils/hexToRgb";

interface LoadingSpinnerProps {
  isGlobal?: boolean;
}

const LoadingSpinner = ({ isGlobal = false }: LoadingSpinnerProps) => {
  const bgc = hexToRgb(defaultTheme.tertiaryColor);
  return (
    <SpinnerWrap $isGlobal={isGlobal} $backgroundColor={bgc}>
      <img src="/assets/buisnessLogo.png" width={"100%"} />
    </SpinnerWrap>
  );
};

const spinnerAnimation = keyframes`
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.9);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
`;

const SpinnerWrap = styled.div<{ $isGlobal: boolean; $backgroundColor: RGB }>`
  z-index: 9999999;
  position: absolute;
  width: 120px;
  height: 120px;
  background-color: rgba(
    ${({ $backgroundColor }) =>
      `${$backgroundColor.r}, ${$backgroundColor.g}, ${$backgroundColor.b},.75`}
  );
  padding: 1rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${spinnerAnimation} 1.5s linear infinite;
  ${(p) =>
    p.$isGlobal
      ? `
    top: calc(50% - 60px);
  left: calc(50% - 60px);
  transform: translate(-50%, -50%);
  `
      : ""}
`;

export default LoadingSpinner;
